export const css = {
	root: '_369qgIpG',
	content: 'bfInpuB2',
	tools: '_2PV3DQpd',
	columns: '_2DgDLDBf',
	trailingColumn: '_2uo_qlZD',
	' _key': 'explore-view/micro-view'
};

export default css;
